/* GCLB October Offer — Buy 2+ boards, get 20% off (added by Claude)
   Loaded from snippets/doc-head-core.liquid only while the offer is live.
   Drives every [data-gclb-oct-end] countdown on the page (announcement bar uses the theme's own timer).
   Works with content the cart drawer re-renders, because it re-queries the timers on every tick.
   When the end time passes it adds .gclb-oct-ended to <html>, which hides all [data-gclb-oct] blocks. */
(function () {
  'use strict';
  var d = document;
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function set(el, sel, val) {
    var t = el.querySelector(sel);
    if (t && t.textContent !== val) t.textContent = val;
  }
  var timer = null;
  function tick() {
    var els = d.querySelectorAll('[data-gclb-oct-end]');
    var now = Date.now();
    var anyLive = false;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = Date.parse(el.getAttribute('data-gclb-oct-end'));
      if (!end) continue;
      var diff = Math.max(0, end - now);
      if (diff > 0) anyLive = true;
      var s = Math.floor(diff / 1000);
      var dd = Math.floor(s / 86400); s -= dd * 86400;
      var hh = Math.floor(s / 3600); s -= hh * 3600;
      var mm = Math.floor(s / 60); s -= mm * 60;
      set(el, '[data-d]', String(dd));
      set(el, '[data-h]', pad(hh));
      set(el, '[data-m]', pad(mm));
      set(el, '[data-s]', pad(s));
      el.classList.toggle('gclb-oct-timer--no-days', dd === 0);
      el.classList.toggle('gclb-oct-timer--final', dd === 0 && hh < 24);
    }
    var cfg = window.GCLB_OCT;
    var globalEnd = cfg && cfg.endMs ? cfg.endMs : 0;
    if ((globalEnd && now >= globalEnd) || (els.length && !anyLive && !globalEnd)) {
      d.documentElement.classList.add('gclb-oct-ended');
      if (cfg) cfg.on = false;
      if (timer) { clearInterval(timer); timer = null; }
    }
  }
  function start() {
    tick();
    if (!timer) timer = setInterval(tick, 1000);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
